import {HttpClient, HttpParams} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {SecurityUtils} from "../security.utils";
import {catchError} from "rxjs/operators";
import {HttpClientUtils} from "../../utils/http-client.utils";
import { Observable } from "rxjs";
import {QueryRangeType} from "./tenant-finance.service";

@Injectable({
  providedIn: 'root'
})
export class AgentService {
  constructor() {}

  private backendUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/agents`;
  private httpClient = inject(HttpClient);

  getWorkstationAgentDeploymentStatistics(tenantId: string, range: QueryRangeType): Observable<GetAgentDeploymentStatisticsResponse> {
    return this.httpClient.get<GetAgentDeploymentStatisticsResponse>(`${this.backendUrl(tenantId)}/workstations/_statistics`, {
      headers: SecurityUtils.getAuthHttpHeaders(),
      params: new HttpParams().set('range', range.valueOf().toLowerCase())
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }

  getWorkstationAgents(tenantId: string): Observable<GetWorkstationAgentsResponse> {
    return this.httpClient.get<GetWorkstationAgentsResponse>(`${this.backendUrl(tenantId)}/workstations`, {
      headers: SecurityUtils.getAuthHttpHeaders(),
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }

  getWorkstationAgentVersions(tenantId: string): Observable<GetWorkstationAgentVersionsResponse> {
    return this.httpClient.get<GetWorkstationAgentVersionsResponse>(`${this.backendUrl(tenantId)}/workstations/_versions`, {
      headers: SecurityUtils.getAuthHttpHeaders(),
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }

  getAgentStatistics(tenantId: string): Observable<GetAgentStatisticsResponse> {
    return this.httpClient.get<GetAgentStatisticsResponse>(`${this.backendUrl(tenantId)}/_statistics`, {
      headers: SecurityUtils.getAuthHttpHeaders(),
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }
}

export interface AgentDeploymentStatisticPoint {
  agentCount: number;
  date: string;
}

export interface GetAgentDeploymentStatisticsResponse {
  statistics: AgentDeploymentStatisticPoint[];
}

export interface WorkstationAgent {
  timestamp: string
  hostname: string
  workstationId: string
  agentVersion: string
  teamId: string
  team: string
  teamPath: string
  status: string
  userRealname: string
  osName: string
}

export interface GetWorkstationAgentsResponse {
  agents: WorkstationAgent[];
}

export interface WorkstationAgentDeployedVersion {
  version: string,
  count: number
}

export interface WorkstationAgentAvailableVersion {
  id: string,
  version: string,
  isDeprecated: boolean
}

export interface GetWorkstationAgentVersionsResponse {
  deployedVersion: WorkstationAgentDeployedVersion[],
  availableVersion: WorkstationAgentAvailableVersion[]
}

export interface GetAgentStatisticsResponse {
  workstationAgentCount: number,
  workstationAgentLatestVersion: string,
  workstationHasAllAgentInLatestVersion: boolean,
  serverAgentCount: number
}